import { propEq } from 'ramda'

import { useNavigation } from '../../utils/contexts/NavigationContext'
import { usePlaceTypes } from '../helpers/placeTypes'

export const entityRootPath = (entity, placeTypes) => {
  switch (entity) {
    case 'serviceOrder':
    case 'service_order':
      return '/service-orders'
    case 'user':
      return '/users'
    case 'checklist':
      return '/checklists'
    default:
      const placeType = placeTypes.find(propEq('key', entity))
      if (placeType) {
        return `/places/${placeType.key}`
      }
      return '/'
  }
}

export const useEntityRootNavigation = entity => {
  const [placeTypes] = usePlaceTypes()
  const navigate = useNavigation()
  return () => navigate(entityRootPath(entity, placeTypes))
}
